import { messageColors } from './consts'

const baseStyle = {
  display: 'flex',
}

const defaultProps = {
  variant: 'info',
  size: 'md',
}

const sizes = {
  sm: {
    iconSize: 'sm',
    fontSize: 'sm',
  },
  md: {
    iconSize: 'md',
    fontSize: 'md',
  },
  lg: {
    iconSize: 'lg',
    fontSize: 'lg',
  },
}

const variants = {
  info: {
    color: messageColors.info,
  },
  warning: {
    color: messageColors.warning,
  },
  error: {
    color: messageColors.error,
  },
  success: {
    color: messageColors.success,
  },
}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
